import Analytics from "./tagAnalytics";
import {TagTypeGa4,EventType} from "./tagType";
import { getJsonTag} from "./tagService";
export default function tagAdapter(config={},type="") {

  const analytics = new Analytics();
  analytics.init();
  let jsonResponse= getJsonTag(config,type);
  switch(type) {
    case TagTypeGa4.ERROR:
      if(!config?.eventLabel){
        config.eventLabel = 'erro-nao-mapeado'
        }
        analytics.setEventGA4(jsonResponse,EventType.CALLBACK)
    break;
    case TagTypeGa4.SUCCESS:
      analytics.setEventGA4(jsonResponse,EventType.CALLBACK)
      break;
    case TagTypeGa4.INPUT:
      analytics.setEventGA4(jsonResponse,EventType.INTERACAO)
      break;
    case TagTypeGa4.PAGEVIEW:
      analytics.setVirtualPageViewGA4(jsonResponse?.title)
      break;
    case TagTypeGa4.FOOTER:
    case TagTypeGa4.BUTTON_MODAL:
    case TagTypeGa4.BUTTON:
      analytics.setEventGA4(jsonResponse,EventType.CLIQUE);
      break;
    default:
      console.log('Type not found',config)
     
  }

  
  };
  export  function tagClaroId(claroId="") {
    const analytics = new Analytics();
    analytics.init();
    analytics.setClaroID(claroId)
    };
   